// 🔌 WebSocket (dedicado a RunToGoal)
let goalSocket = null
let goalIsConnected = false
let goalReconnectTimeout = null
let goalReconnectAttempts = 0
const MAX_RECONNECT_ATTEMPTS = 10


const ConnectGoalWebSocket = async (playerId, onStatus = () => {}, onToast = () => {}) => {
  if (goalSocket || goalIsConnected) return
  const connect = () => {
    if (goalReconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      onStatus('error'); return
    }
    goalReconnectAttempts++
    goalSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=goal:${playerId}`)
    onStatus('connecting')

    goalSocket.onopen = () => {
      goalIsConnected = true
      goalReconnectAttempts = 0
      onStatus('connected')
      onToast('Conectado')
    }
    goalSocket.onclose = () => {
      goalIsConnected = false
      goalSocket = null
      onStatus('reconnecting')
      goalReconnectTimeout = setTimeout(connect, 2000)
    }
    goalSocket.onerror = () => onStatus('error')
  }
  connect()
}

const SetGoalSocketMessageHandler = (handler) => {
  if (!goalSocket) return
  goalSocket.onmessage = (evt) => {
    try { handler(JSON.parse(evt.data)) } catch {}
  }
}

const ClearGoalSocketMessageHandler = () => {
  if (goalSocket) goalSocket.onmessage = null
}

const DisconnectGoalWebSocket = () => {
  try {
    if (goalSocket) {
      goalSocket.onopen = goalSocket.onclose = goalSocket.onerror = goalSocket.onmessage = null
      goalSocket.close()
      goalSocket = null
      goalIsConnected = false
      clearTimeout(goalReconnectTimeout)
      goalReconnectAttempts = 0
    }
  } catch {}
}

// 📡 REST (DL muy simple aquí mismo)
const SendTaps = async ({ matchId, playerId, taps }) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}RunToGoal/add-taps`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ matchId, playerId, taps })
    })
    return { success: res.ok }
  } catch {
    return { success: false }
  }
}

export { ConnectGoalWebSocket, SetGoalSocketMessageHandler, ClearGoalSocketMessageHandler, DisconnectGoalWebSocket, SendTaps }